import React from 'react'
import { useHistory } from 'react-router-dom'

import { setCustomerCookie } from 'redux/api/Cookie'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useCustomer } from 'redux/hooks/Customer'
import { useInternalCustomers } from 'redux/hooks/internal/Customers'
import { useTestEnvironmentActions } from 'redux/actions/TestEnvironment'

import SelectSearch, { Option } from 'components_new/molecules/SelectSearch'

import { includeCustomer } from './Exceptions'

/** Only Homepal may fetch our customers. */
const SelectCustomer = () => {
  const { isHomepal } = useAccountSettings()

  return isHomepal ? <CustomerPicker /> : null
}

const CustomerPicker = () => {
  const { account } = useAccountSettings()
  const { customers } = useInternalCustomers()
  const customer = useCustomer()
  const history = useHistory()
  const { updateTestEnvironment } = useTestEnvironmentActions()

  const options: Option[] = customers
    .filter((customer) => includeCustomer(account, customer))
    .map((customer) => ({
      title: customer.name,
      id: customer.id
    }))

  if (!customer) return null

  return (
    <SelectSearch
      closeOnSelect={true}
      onChange={(selected) => {
        if (selected) {
          // Reset the test environment so the 'test' variant doesn't
          // leak into the newly selected customer, which might not
          // have a test environment.
          if (account) {
            updateTestEnvironment(account.id, 'prod')
          }

          setCustomerCookie(selected.id as string).then(() => {
            history.push('/')

            window.location.reload()
          })
        }
      }}
      options={options}
      selected={{ id: customer.customer_id, title: customer.name }}
      sort
      label={'Kund'}
      multiple={false}
    />
  )
}

export default SelectCustomer
